import React, {useEffect} from 'react'
import {useNavigate} from "react-router-dom"
import {useDispatch} from "react-redux"
import {paymentActions} from "../../common/store/payment.state"

export const EnrollmentPaymentConfirmPage = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(paymentActions.disable())

        setTimeout(() => {
            navigateToEnrollments()
        }, 10000)
    }, [])

    const navigateToEnrollments = () => {
        navigate(`/enrollments`, {replace: true})
    }

    return (
        <div style={{display: "flex", flexDirection: "column"}}>
            <h5 style={{textAlign: "center", fontSize: "30px"}}>Procedura di pagamento terminata.</h5>
            <h3 style={{textAlign: "center"}}>
                Verrà inviata un'email quando il pagamento risulterà andato a buon fine.
                <br />
                Tra 10 secondi sarai reindirizzato, altrimenti clicca
                <a style={{marginLeft: '3px'}} onClick={() => navigateToEnrollments()}>qui</a>.
            </h3>
        </div>
    )
}